import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import { InhouseGameDetails } from 'config/types/game'
import { useState } from 'react'
import styled from 'styled-components'
import { StyledGameBoard } from 'views/InhouseGame/components/styled'
import { GameInHouseConfig } from 'views/InhouseGame/config/types'
import GameGraphic from './components/GameGraphic'
import Loader from './components/Loader'
import PayoutGroup from './components/PayoutGroup'
import UserPayout from './components/UserPayout'
import { Risk, canvasHeight, canvasWidth, plinkoDistancesX } from './config'

const GameBoard: React.FC<{ row: number; risk: Risk; game: InhouseGameDetails } & GameInHouseConfig & BoxProps> = ({
  risk,
  row,
  volumeEnable,
  game,
  ...props
}) => {
  const widthScale = (plinkoDistancesX[row] - 0.2) / canvasWidth
  const [isRendered, setIsRendered] = useState(false)

  return (
    <StyledGameBoardWrapper
      justifyContent="center"
      p={['24px 0', '', '', '', '', '20px']}
      position="relative"
      {...props}
    >
      <Box height={['100%']}>
        <GameGraphic
          canvasWidth={canvasWidth}
          canvasHeight={canvasHeight}
          height={['unset', '', '', '', 'calc(100% - 1.8em)']}
          width={['100% !important', '', '', '', 'unset !important']}
          row={row}
          onRendered={() => {
            setIsRendered(true)
          }}
        />
        <StyledPayoutGroup
          maxWidth={['100% !important', '', '', '', '100%']}
          maxHeight={`${canvasHeight}px`}
          row={row}
          risk={risk}
          widthScale={widthScale}
          volumeEnable={volumeEnable}
        />
        <UserPayout row={row} risk={risk} game={game} />
      </Box>

      <Loader isFinished={isRendered} />
    </StyledGameBoardWrapper>
  )
}

const StyledGameBoardWrapper = styled(StyledGameBoard)`
  aspect-ratio: 0;

  ${({ theme }) => theme.mediaQueries.lg} {
    aspect-ratio: 1/1;
  }

  ${({ theme }) => theme.mediaQueries.xxxl} {
    height: auto;
  }
`

const StyledPayoutGroup = styled(PayoutGroup)`
  font-size: 0.5em;

  ${({ theme }) => theme.mediaQueries.xs} {
    font-size: 0.6em;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 0.8em;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 1em;
  }
`

export default GameBoard
